import React from "react"
import badge from "badges/magic-of-letters.svg"
import { BadgeImage } from "backpack/badges/styled"

const MagicOfLetters = props => <BadgeImage src={badge} {...props} />

export default MagicOfLetters
